// extracted by mini-css-extract-plugin
export default {"iconButton":"iconBtn_iconButton__OCqbw","iconButtonWithText":"iconBtn_iconButtonWithText__Bg3a1","iconButtonWithTextBlack":"iconBtn_iconButtonWithTextBlack__2uxr1"};